export default __webpack_public_path__ + "static/media/adaptive-card.b1cbae88.svg";